module.exports = __webpack_public_path__ + "static/media/faq_img_2.676d5673.svg";